import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export const BillingsAccessRight = {
  VIEW_BILLINGS: ({ menuDisplayLevel, isBilling }) =>
    menuDisplayLevel === 0 && isBilling,
} satisfies Record<string, AuthenticationAccessRight>;
